import FilterListGlobalList from 'common/pages/filter-list-global/FilterListGlobalList.tsx'

export const FilterListGlobalListAdmin = (props: any) => <FilterListGlobalList {...props} admin />